import Input from "models/input/input";

export default function SortInput(
  keyA: string | number,
  keyB: string | number,
  input: Input,
) {
  if (
    input.metadata[keyA]?.data_type === "standard" &&
    input.metadata[keyB]?.data_type !== "standard"
  ) {
    return -1;
  } else if (
    input.metadata[keyA]?.data_type !== "standard" &&
    input.metadata[keyB]?.data_type === "standard"
  )
    return 1;
  else if (input.metadata[keyA] && input.metadata[keyB])
    return input.metadata[keyA].position - input.metadata[keyB].position;
  else return input.metadata[keyA] ? -1 : 1;
}
